import { render } from "./Vaccinations.vue?vue&type=template&id=49dd48e1&scoped=true"
import script from "./Vaccinations.vue?vue&type=script&lang=js"
export * from "./Vaccinations.vue?vue&type=script&lang=js"

import "./Vaccinations.vue?vue&type=style&index=0&id=49dd48e1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49dd48e1"]])

export default __exports__